export function hasSeriousAnalysisErrors(analysisData = {}, improvements = []) {
  return (
    analysisData?.overall_status === "fail" ||
    improvements.some((item) => item.severity === "error")
  );
}

export function reportNeedsProcessPrefill(report) {
  if (!report) {
    return false;
  }

  return (
    (!report.approved && !report.not_approved) ||
    report.updated_after_process
  );
}

export function buildReportProcessDefaults(report) {
  const base = {
    id: report?.id,
    process: true,
    approved: Boolean(report?.approved),
    not_approved: Boolean(report?.not_approved),
    process_note: report?.process_note || "",
  };

  if (!reportNeedsProcessPrefill(report)) {
    return base;
  }

  const analysisData = report?.analysis_data || {};
  const improvements = analysisData?.improvements || [];
  const seriousErrors = hasSeriousAnalysisErrors(analysisData, improvements);
  const suggestedNote = analysisData?.suggested_analysis_note?.trim() || "";

  if (seriousErrors) {
    return {
      ...base,
      approved: false,
      not_approved: true,
      process_note: suggestedNote || base.process_note,
    };
  }

  if (suggestedNote && !base.process_note) {
    return {
      ...base,
      process_note: suggestedNote,
    };
  }

  return base;
}
